import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Ikr998ErtUsers } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { Kr998ErtUsersService } from "../../../services/kr998ErtUsers/kr998ErtUsers.service";
import { AttendanceStatus } from "../../../interfaces/ert-kr998ErtUsers/ert-kr998-attendancestatus";
import { ActivatedRoute, Router } from "@angular/router";
import { Kr998Service } from "../../../services/kr998/kr998.service";
import { LoggedUserService } from "../../../services/common/logged-user.service";

@Component({
  selector: "app-ert-kr998-update-attendance",
  templateUrl: "./ert-kr998-update-attendance.component.html",
  styleUrl: "",
})
export class ErtKr998UpdateAttendanceComponent implements OnInit {
  empErtEduDetails = new MatTableDataSource<Ikr998ErtUsers>();
  empErtInstructorsDetails = new MatTableDataSource<Ikr998ErtUsers>();
  totalEduItems: number;
  totalErtInstructorsItems: number;
  selectedEduItemsCount: number = 0;
  selectedErtInstructorsItemsCount: number = 0;
  displayedColumnsArray: string[] = [
    "select",
    "ERT_KR_998_Details_Mem",
    "ERT_KR_998_Details_Attend",
  ];

  facilityId: number;

  constructor(
    private kr998ErtUserService: Kr998ErtUsersService,
    private route: ActivatedRoute,
    private k998Service: Kr998Service,
    private router: Router,
    private loggedUser: LoggedUserService
  ) {}

  ngOnInit(): void {
    this.loggedUser.getLoggedUserData().subscribe((user) => {
      this.facilityId = Number(user?.facilityId) || 0;
      this.loadKr998ErtUsers();
    });
  }

  loadKr998ErtUsers(): void {
    const id = +this.route.snapshot.paramMap.get("id")!;
    this.k998Service.getKr998(id, this.facilityId).subscribe((users) => {
      this.empErtEduDetails.data = users.kr998ErtUsers.filter(
        (user) => !user.isInstructior
      );
      this.empErtInstructorsDetails.data = users.kr998ErtUsers.filter(
        (user) => user.isInstructior
      );
      this.totalEduItems = this.empErtEduDetails.data.length;
      this.totalErtInstructorsItems = this.empErtInstructorsDetails.data.length;
    });
  }

  toggleSelection(element: Ikr998ErtUsers, isEdu: boolean): void {
    element.isSelected = !element.isSelected;

    if (isEdu) {
      this.selectedEduItemsCount = this.empErtEduDetails.data.filter(
        (user) => user.isSelected
      ).length;
    } else {
      this.selectedErtInstructorsItemsCount =
        this.empErtInstructorsDetails.data.filter(
          (user) => user.isSelected
        ).length;
    }
  }

  submitAttendance(): void {
    const selectedUsers = [
      ...this.empErtEduDetails.data.filter((user) => user.isSelected),
      ...this.empErtInstructorsDetails.data.filter((user) => user.isSelected),
    ];

    selectedUsers.forEach((user) => {
      user.attendanceStatus = AttendanceStatus.Attended;
      user.userErt.hireDate = new Date();
      user.userErt.withdrewDate = new Date();
      user.userErt.ertDate = new Date();
    });

    this.kr998ErtUserService.updateAttendanceStatus(selectedUsers).subscribe({
      next: () => {
        this.router.navigate([
          "/ert-kr998/ert-kr998-view",
          this.route.snapshot.paramMap.get("id"),
        ]);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getAttendanceStatus(status: number): string {
    return status === AttendanceStatus.Attended ? "Attended" : "";
  }
  onCancel(): void {
    this.router.navigate(['/ert-kr998/ert-kr998-view', this.route.snapshot.paramMap.get('id')]);
  }
}
